import { PaymentConst } from '../constants';

const PaymentDataReducer = (state = { requesting: false, data: {} }, action) => {
    switch (action.type) {
        case PaymentConst.FETCH_PAYMENT_DATA_REQUEST:
            return { ...state, requesting: true };
        case PaymentConst.FETCH_PAYMENT_DATA_SUCCESS:
            return { ...state, requesting: false, data: action.payload };
        case PaymentConst.FETCH_PAYMENT_DATA_FAILURE:
            return { ...state, requesting: false, data: action.payload };
        default:
            return state;
    }
};

const PaymentLinkReducer = (state = { requesting: false, data: {} }, action) => {
    switch (action.type) {
        case PaymentConst.GENERATE_PAYMENT_LINK_REQUEST:
            return { ...state, requesting: true };
        case PaymentConst.GENERATE_PAYMENT_LINK_SUCCESS:
            return { ...state, requesting: false, data: action.payload };
        case PaymentConst.GENERATE_PAYMENT_LINK_FAILURE:
            return { ...state, requesting: false, data: action.payload };
        case PaymentConst.RESET_PAYMENT_LINK:
            return { requesting: false, data: {} };
        default:
            return state;
    }
};

const ConfirmClaimCodeReducer = (state = { requesting: false, data: {} }, action) => {
    switch (action.type) {
        case PaymentConst.CONFIRM_CLAIM_CODE_REQUEST:
            return { ...state, requesting: true };
        case PaymentConst.CONFIRM_CLAIM_CODE_SUCCESS:
            return { ...state, requesting: false, data: action.payload };
        case PaymentConst.CONFIRM_CLAIM_CODE_FAILURE:
            return { ...state, requesting: false, data: action.payload };
        default:
            return state;
    }
};

const BankListReducer = (state = { requesting: false, data: {} }, action) => {
    switch (action.type) {
        case PaymentConst.FETCH_BANKS_REQUEST:
            return { ...state, requesting: true };
        case PaymentConst.FETCH_BANKS_SUCCESS:
            return { ...state, requesting: false, data: action.payload };
        case PaymentConst.FETCH_BANKS_FAILURE:
            return { ...state, requesting: false, data: action.payload };
        default:
            return state;
    }
};

const ResolveBankReducer = (state = { requesting: false, data: {} }, action) => {
    switch (action.type) {
        case PaymentConst.RESOLVE_BANK_REQUEST:
            return { ...state, requesting: true };
        case PaymentConst.RESOLVE_BANK_SUCCESS:
            return { ...state, requesting: false, data: action.payload };
        case PaymentConst.RESOLVE_BANK_FAILURE:
            return { ...state, requesting: false, data: action.payload };
        default:
            return state;
    }
};

const ClaimPayoutReducer = (state = { requesting: false, data: {} }, action) => {
    switch (action.type) {
        case PaymentConst.CLAIM_PAYOUT_REQUEST:
            return { ...state, requesting: true };
        case PaymentConst.CLAIM_PAYOUT_SUCCESS:
            return { ...state, requesting: false, data: action.payload };
        case PaymentConst.CLAIM_PAYOUT_FAILURE:
            return { ...state, requesting: false, data: action.payload };
        case PaymentConst.RESET_CLAIM_PAYOUT:
            return { requesting: false, data: {} };
        default:
            return state;
    }
};

const VasServicesReducer = (state = { requesting: false, data: {} }, action) => {
    switch (action.type) {
        case PaymentConst.FETCH_VAS_SERVICES_REQUEST:
            return { ...state, requesting: true };
        case PaymentConst.FETCH_VAS_SERVICES_SUCCESS:
            return { ...state, requesting: false, data: action.payload };
        case PaymentConst.FETCH_VAS_SERVICES_FAILURE:
            return { ...state, requesting: false, data: action.payload };
        default:
            return state;
    }
};

const VasCategoriesReducer = (state = { requesting: false, data: {} }, action) => {
    switch (action.type) {
        case PaymentConst.FETCH_VAS_CATEGORIES_REQUEST:
            return { ...state, requesting: true };
        case PaymentConst.FETCH_VAS_CATEGORIES_SUCCESS:
            return { ...state, requesting: false, data: action.payload };
        case PaymentConst.FETCH_VAS_CATEGORIES_FAILURE:
            return { ...state, requesting: false, data: action.payload };
        default:
            return state;
    }
};

const VasProductsReducer = (state = { requesting: false, data: {} }, action) => {
    switch (action.type) {
        case PaymentConst.FETCH_VAS_PRODUCTS_REQUEST:
            return { ...state, requesting: true };
        case PaymentConst.FETCH_VAS_PRODUCTS_SUCCESS:
            return { ...state, requesting: false, data: action.payload };
        case PaymentConst.FETCH_VAS_PRODUCTS_FAILURE:
            return { ...state, requesting: false, data: action.payload };
        default:
            return state;
    }
};

const VerifyVasEntityReducer = (state = { requesting: false, data: {} }, action) => {
    switch (action.type) {
        case PaymentConst.VERIFY_VAS_ENTITY_REQUEST:
            return { ...state, requesting: true };
        case PaymentConst.VERIFY_VAS_ENTITY_SUCCESS:
            return { ...state, requesting: false, data: action.payload };
        case PaymentConst.VERIFY_VAS_ENTITY_FAILURE:
            return { ...state, requesting: false, data: action.payload };
        default:
            return state;
    }
};

export {
    PaymentDataReducer,
    PaymentLinkReducer,
    ConfirmClaimCodeReducer,
    BankListReducer,
    ResolveBankReducer,
    ClaimPayoutReducer,
    VasServicesReducer,
    VasCategoriesReducer,
    VasProductsReducer,
    VerifyVasEntityReducer
};
